import 'reflect-metadata';
import type { Meta } from '../interfaces/Meta';
import { NOOP } from './consts';

const COMPONENT_EVENT_HANDLER = `COMPONENT_EVENT_HANDLER`;
const COMPONENT_PROPERTY_KEY = `COMPONENT_PROP_KEY`;
const TRANSFORMER_PROP_KEY = `TRANSFORMER_PROP_KEY`;

export function handler(target: Object, propertyKey: string) {
  const meta = Reflect.getMetadata(COMPONENT_EVENT_HANDLER, target) || [];
  meta.push(propertyKey);
  Reflect.defineMetadata(COMPONENT_EVENT_HANDLER, meta, target);
}

export function property(target: Object, propertyKey: string) {
  const meta = Reflect.getMetadata(COMPONENT_PROPERTY_KEY, target) || [];
  meta.push(propertyKey);
  Reflect.defineMetadata(COMPONENT_PROPERTY_KEY, meta, target);
}

export function transformer(target: Object, propertyKey: string) {
  const meta = Reflect.getMetadata(TRANSFORMER_PROP_KEY, target) || [];
  meta.push(propertyKey);
  Reflect.defineMetadata(TRANSFORMER_PROP_KEY, meta, target);
}

export function makeMetadata(target: { $meta: Meta }) {
  const properties = Reflect.getMetadata(COMPONENT_PROPERTY_KEY, target) as string[];
  const handlers = Reflect.getMetadata(COMPONENT_EVENT_HANDLER, target) as string[];
  const transformers = Reflect.getMetadata(TRANSFORMER_PROP_KEY, target) as string[];

  (properties ?? []).forEach((key) => target.$meta.properties.add(key));
  (handlers ?? []).forEach((key) => target.$meta.handlers.add(key));
  (transformers ?? []).forEach((key) => target.$meta.transformers.add(key));
}

export function getTransformer(target: Object & { $meta: Meta }, signature: string): Function {
  const transformers = [];
  target.$meta.transformers.forEach((key) => {
    if (key.includes(signature)) transformers.push(key);
  });
  if (!transformers.length) return NOOP;
  const fnName = transformers.pop();
  return target[fnName].bind(target);
}
